import { createMemoryRouter } from "react-router-dom";
import { AuthenticatedApp } from "../pages/AuthenticatedApp";
import { AuthenticationApp } from "../pages/AuthenticationApp";
import App from "../taskpane/components/App";
import { authLoader } from "./loaders/authLoader";
import { LoginLoader } from "./loaders/loginLoader";
import { ProtectedRoute } from "./ProtectedRoute";

export const router = createMemoryRouter(
  [
    {
      element: <App />,
      id: "root",
      children: [
        {
          loader: authLoader,
          element: <ProtectedRoute key={"protected-route"} />,
          children: [
            {
              path: "/",
              element: <AuthenticatedApp />,
            },
          ],
        },
        {
          loader: LoginLoader,
          path: "/login",
          element: <AuthenticationApp />,
        },
      ],
    },
  ],
  { initialEntries: ["/login"] }
);
